import { ITEM_TYPE } from '@/utils/enum';
import { rebuildAttachTreeOrder } from './nestAttachItems';

function getMainItems(listBillItem) {
  return listBillItem.filter((item) => item.itemType === ITEM_TYPE.MAIN);
}

function getChildItems(listBillItem) {
  return listBillItem.filter((item) => item.itemType !== ITEM_TYPE.MAIN);
}

export default function sortListBillItem(listBillItem) {
  if (!listBillItem || listBillItem.length === 0) {
    return [];
  }

  const mainItems = getMainItems(listBillItem);
  const childItems = getChildItems(listBillItem);

  return rebuildAttachTreeOrder(mainItems, childItems, {
    mainIdField: 'id',
    parentField: 'belongBillDetailId',
    attachItemType: ITEM_TYPE.ATTACH,
    itemTypeField: 'itemType',
  });
}
